"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonNavigationBarPopover = void 0;
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var utils_2 = require("@qwilr/kaleidoscope/utils");
var CommonNavigationBarPopover = (function (_super) {
    __extends(CommonNavigationBarPopover, _super);
    function CommonNavigationBarPopover(props) {
        var _this = _super.call(this, props) || this;
        _this.triggerButtonRef = react_1.default.createRef();
        _this.isTooltipLocked = false;
        _this.popoverWrapperClass = "".concat(_this.props.action.actionClass, "-popover-wrapper");
        _this.isVisible = false;
        _this.onClickOutside = new utils_1.OnClickOutside(__spreadArray([".".concat(_this.popoverWrapperClass)], __read(props.ignoreElements), false), function () {
            _this.setVisibility(false);
        });
        return _this;
    }
    CommonNavigationBarPopover.prototype.componentWillUnmount = function () {
        this.onClickOutside.stopListening();
    };
    CommonNavigationBarPopover.prototype.render = function () {
        var _a = this.props, children = _a.children, childClassname = _a.childClassname;
        return (react_1.default.createElement("div", { className: "navigation-actions__button-container", onKeyDown: this.handleKeyDown, tabIndex: 0 },
            react_1.default.createElement("div", { className: this.popoverWrapperClass },
                this.renderButton(),
                react_1.default.createElement(react_transition_group_1.Transition, { mountOnEnter: true, unmountOnExit: true, onEnter: utils_2.forceReflow, in: this.isVisible, timeout: kaleidoscope_3.AnimationDuration.Medium }, function (transitionStatus) { return (react_1.default.createElement("div", { id: childClassname, className: (0, classnames_1.default)("".concat(childClassname), "".concat(childClassname, "--").concat(transitionStatus)) }, children)); }))));
    };
    CommonNavigationBarPopover.prototype.renderButton = function () {
        var _a;
        var _b = this.props, action = _b.action, childClassname = _b.childClassname, isButtonDisabled = _b.isButtonDisabled, buttonDisabledReason = _b.buttonDisabledReason, tooltipSize = _b.tooltipSize;
        var icon = action.icon, actionClass = action.actionClass, text = action.text, name = action.name, href = action.href;
        var props = (_a = {
                ref: this.triggerButtonRef,
                className: actionClass,
                href: href,
                onClick: this.onTriggerButtonClick,
                onMouseEnter: this.unlockTooltip,
                disabled: isButtonDisabled,
                disabledReason: buttonDisabledReason,
                tooltip: {
                    size: tooltipSize !== null && tooltipSize !== void 0 ? tooltipSize : kaleidoscope_1.TooltipSize.Small,
                    content: name,
                    position: kaleidoscope_1.TooltipPosition.Bottom,
                    show: this.isTooltipLocked ? false : undefined,
                }
            },
            _a["aria-haspopup"] = true,
            _a["aria-expanded"] = this.isVisible,
            _a["aria-owns"] = childClassname,
            _a);
        return text ? (react_1.default.createElement(kaleidoscope_2.Button, __assign({ type: kaleidoscope_2.ButtonType.Secondary, size: kaleidoscope_2.ButtonSize.Medium }, props),
            icon,
            text)) : (react_1.default.createElement(kaleidoscope_2.IconButton, __assign({ icon: icon, size: kaleidoscope_2.ButtonSize.Small }, props)));
    };
    CommonNavigationBarPopover.prototype.unlockTooltip = function () {
        if (!this.isVisible) {
            this.isTooltipLocked = false;
        }
    };
    CommonNavigationBarPopover.prototype.onTriggerButtonClick = function () {
        var _a, _b;
        this.setVisibility(!this.isVisible);
        (_b = (_a = this.triggerButtonRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.blur();
        if (this.props.onButtonClick) {
            this.props.onButtonClick(this.isVisible);
        }
    };
    CommonNavigationBarPopover.prototype.setVisibility = function (isVisible) {
        this.isVisible = isVisible;
        if (this.isVisible) {
            this.isTooltipLocked = true;
            this.onClickOutside.startListening();
        }
        else {
            this.onClickOutside.stopListening();
        }
    };
    CommonNavigationBarPopover.prototype.handleKeyDown = function (event) {
        if (event.key === "Escape") {
            this.setVisibility(false);
        }
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], CommonNavigationBarPopover.prototype, "isVisible", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], CommonNavigationBarPopover.prototype, "isTooltipLocked", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CommonNavigationBarPopover.prototype, "unlockTooltip", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CommonNavigationBarPopover.prototype, "onTriggerButtonClick", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], CommonNavigationBarPopover.prototype, "setVisibility", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof react_1.default !== "undefined" && react_1.default.KeyboardEvent) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], CommonNavigationBarPopover.prototype, "handleKeyDown", null);
    CommonNavigationBarPopover = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], CommonNavigationBarPopover);
    return CommonNavigationBarPopover;
}(react_1.default.Component));
exports.CommonNavigationBarPopover = CommonNavigationBarPopover;
